module.exports = __webpack_public_path__ + "img/poster2.85ec8119.png";